import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Pressable, ScrollView, StyleSheet, TextInput as RNTextInput, View } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { CustomDivider } from "@/components/CustomDivider";
import { ArrowIcon, Button as Button95, Checkbox, Hourglass, NumberInput, Panel, Slider, Text, TextInput } from 'react95-native-rabbl';
import Head from 'expo-router/head';
import { CustomText } from '@/components/CustomText';
import Footer from '@/components/Footer';
import * as AppUtilities from "@/utilities/AppUtilities";
import * as AppUtils from '@/utilities/AppUtils';
import * as AppConstants from "@/utilities/AppConstants";
import * as AppConsts from "@/utilities/AppConsts";
import { useForm, Controller, Resolver } from "react-hook-form";
import { AppContext } from '@/components/AppContext';
import { CommunityMembership } from "@/types/community_membership";
import { RelativePathString, useLocalSearchParams, useRouter } from 'expo-router';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { updateMapFilters, updateMen, updateWomen } from '@/state/mapfilters';
import { AppText } from '@/components/AppText';
import { MatchesFilter } from '@/components/MatchesFilter';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 10,
    gap: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
  formElement: {
    width: AppConsts.BASIC_MINIMUM_WIDTH,
  },
  buttonWrapper: {
    flexDirection: 'row',
  },
  panel: {
    padding: 20,
    gap: 20,
    alignItems: 'center',
  },
  numericWrapper: {
    flexDirection: 'row',
    gap: 5,
  },
  numeric: {
    width: 80,
  },
});

export default function MapFilter() {
  const domain = useSelector((state: RootState) => state.user.domain);
  const { showSpinner, hideSpinner } = useContext(AppContext);
  const router = useRouter();
  const dispatch = useDispatch();
  const men = useSelector((state: RootState) => state.mapFilters.men);
  const women = useSelector((state: RootState) => state.mapFilters.women);
  const filterAgeMin = useSelector((state: RootState) => state.mapFilters.ageMin);
  const filterAgeMax = useSelector((state: RootState) => state.mapFilters.ageMax);
  const filterHeightMin = useSelector((state: RootState) => state.mapFilters.heightMin);
  const filterHeightMax = useSelector((state: RootState) => state.mapFilters.heightMax);
  const [filterMen, setFilterMen] = useState(men);
  const [filterWomen, setFilterWomen] = useState(women);

  const onSubmit = useCallback(async(ageMin : number, ageMax : number, heightMin : number, heightMax : number, maxDistance : number) => {
    try {

      AppUtilities.info("MapFilter.onSubmit filterMen: " + filterMen + ", filterWomen: " + filterWomen);

      dispatch(updateMapFilters({
        men: filterMen,
        women: filterWomen,
        ageMin: ageMin,
        ageMax: ageMax,
        heightMin: heightMin,
        heightMax: heightMax
      }));

      router.dismissTo("/map");

    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSubmit(ageMin, ageMax, heightMin, heightMax, maxDistance), true);
      AppUtilities.handleException(e, "MapFilter.onSubmit");
    }
  }, [router, domain, filterMen, filterWomen]);

  return (
    <BasicScrollView center={true}>
      <Meta title={"Map Filter"} />

      <Panel variant='raised' elevation={4}>
        <View style={styles.panel}>

          <View>
            <Checkbox
              status={filterMen ? 'checked' : 'unchecked'}
              onPress={() => setFilterMen(filterMen ? false : true)}
              label={"Men"}
            />
          </View>
          <View>
            <Checkbox
              status={filterWomen ? 'checked' : 'unchecked'}
              onPress={() => setFilterWomen(filterWomen ? false : true)}
              label={"Women"}
            />
          </View>

          <CustomDivider fullWidth={true} />

          <MatchesFilter
            onSubmit={onSubmit}
            showDistance={false}
            baselineAgeMin={filterAgeMin}
            baselineAgeMax={filterAgeMax}
            baselineHeightMin={filterHeightMin}
            baselineHeightMax={filterHeightMax}
            baselineMaxDistance={0}
          />
        </View>
      </Panel>
      
      <Footer />
    </BasicScrollView>
  );
}
